const translations = {
  page_title: 'Deals',

  deals_found_n: 'Deals found: {{n}}',
  search_placeholder: 'Search by make, model or VIN',
  new_deal: 'New deal',

  no_deals_search: 'There are no deals that match your search',
  no_deals: 'There are no deals yet',
  start_a_deal: 'Start a new deal to see it listed here',

  id: 'ID',
  image: 'Image',
  buyer: 'Buyer',
  seller: 'Seller',
  seller_2: 'Seller 2',
  days_column: 'Days',
  day: 'day',
  price: 'Price',
  vin: 'VIN',
  status: 'Status',
  status_open: 'Open',
  status_pending: 'Pending',
  status_done: 'Done',
  status_cancelled: 'Cancelled',

  edit_deal: 'Edit deal',
  view_deal: 'View deal',
  days: 'days',

  description: 'Description',
  receipt_number: 'Receipt number',
  amount: 'Amount',
  added_at: 'Added',
  add_receipt: 'Add receipt',
  enter_amount: 'Enter amount',
  enter_description: 'Enter description',
  enter_number: 'Enter number',
  additional_message: 'Additional message',
  enter_additional_message: 'Enter additional message',
  bulk_actions: 'Bulk actions',
  delete_selected: 'Delete selected',
  download_selected: 'Download selected',

  deal_product_deleted_succesfully: 'Deal product deleted successfully',
  remove_deal_products: 'Remove deal products',
  remove_deal_product: 'Remove deal product',
  deal_products_remove_description: 'Are you sure you want to remove the selected deal products?',
  deal_product_remove_description: 'Are you sure you want to remove the selected deal product?',
  edit_deal_product: 'Edit product',
  add_deal_product: 'Add product',
  category: 'Category',
  name: 'Name',
  deal_products: 'Deal products',
  deal_products_description:
    'Add and manage optional products or services to include in the vehicle deal.',
  no_products_added: 'No products added yet',

  uploaded: 'Uploaded',
  not_uploaded: 'Not uploaded',
  add_item: 'Add item',
  item: 'Item',
  units: 'Units',
  unit_price: 'Unit price',
  notes: 'Notes',
  date: 'Date',

  close_deal: 'Close deal',
  close_deal_description: 'Are you sure you want to close this deal?',
  deal_closed_success: 'Deal closed successfully',
  deal_closed_error: 'There are validation errors. Please fix them and try again.',

  set_deal_pending: 'Set as Pending',
  set_deal_pending_description: 'Are you sure you want to set this deal as pending?',
  deal_pending_success: 'Deal set as pending successfully',
  deal_pending_error: 'There was an error',

  cancel_deal: 'Cancel deal',
  cancel_deal_description: 'Are you sure you want to cancel this deal?',
  deal_cancelled_success: 'Deal cancelled successfully',
  deal_cancelled_error: 'There was an error.',

  all: 'All',
  open: 'Open',
  pending: 'Pending',
  done: 'Done',
  cancelled: 'Cancelled',

  last_month: 'Last month',
  previous_month: 'Previous month',
  prev_month: 'Prev. month',
  open_deals: 'Open deals',
  closed_deals: 'Closed deals',
  pending_deals: 'Pending deals',
  front_gross: 'Front gross',
  products: 'Products',

  this_month: 'This month',
  custom: 'Custom',
  sort_custom: 'Custom',

  deal: 'Deal',
  type: 'Type',
  sale_price: 'Sale price',

  vehicle: 'Vehicle',
  stock_number: 'Stock #',

  mail: 'Email',
  phone: 'Phone',

  trade_in: 'Trade-in',
  trade_in_allowance: 'Allowance',
  trade_in_mileage: 'Mileage',

  finance: 'Finance',
  financing_amount: 'Amount',
  financing_apr: 'APR',

  vehicle_cost: 'Vehicle cost',
  rebate: 'Rebate',
  trade_in_allowance_2: 'Allowance 2nd trade-in',
  conditioning: 'Conditioning',

  no_data: 'No data available',
  est_profit: 'Est. profit',
  allowance: 'Allowance',
  mileage: 'Mileage',
  apr: 'APR',
  email: 'Email',
};

export default translations;
